import { RegexValidator } from './RegexValidator'

export class TimingValidator extends RegexValidator {
    constructor() {
        //eslint-disable-next-line
        super(/^[0-5][0-9]:[0-5][0-9]$/, 'validations.timing')
    }
}
